import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

document.addEventListener("turbo:load", () => {
  flatpickr("[data-behavior='flatpickr-date']", {
    dateFormat: 'Y-m-d',
    "locale": Russian,
    defaultDate: 'today',
    minDate: 'today'
  })
})
